import { CronStatusPage } from "@/components/cron-status/cron-status-page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/cron-status/")({
  component: CronStatusPage,
});
